import { Link } from 'react-router';
import { PATHS } from '@client/routes';
import { Alert } from '@mui/material';
import {
  CustomDomainStatus,
  useCustomDomainsQuery,
} from '../../../generated/graphql';
import _ from 'lodash';

export const CustomDomainBanner = ({
  influencerId,
}: {
  influencerId: number;
}) => {
  const { data, loading, error } = useCustomDomainsQuery({
    variables: {
      id: influencerId,
    },
    fetchPolicy: 'no-cache',
  });

  if (error || loading) {
    return null;
  }

  const display = {
    setupDomainInstruction: Boolean(
      !data?.creator?.customDomains ||
        data.creator.customDomains.length === 0 ||
        ![
          CustomDomainStatus.DnsVerified,
          CustomDomainStatus.InfraRunning,
        ].includes(data.creator.customDomains[0].status),
    ),
    domainIsBeingConfigured: Boolean(
      data?.creator?.customDomains?.length &&
        data.creator.customDomains[0].status === CustomDomainStatus.DnsVerified,
    ),
    domainIsConfigured: Boolean(
      data?.creator?.customDomains?.length &&
        data?.creator.customDomains[0].status ===
          CustomDomainStatus.InfraRunning,
    ),
  };

  const domainData = data?.creator?.customDomains?.length
    ? data.creator.customDomains[0]
    : null;

  return (
    <div>
      {display.setupDomainInstruction && (
        <Alert severity="info" className="my-4 bg-[#C2D2EC]">
          You can set up your custom domain name&nbsp;
          <Link
            to={PATHS.CUSTOM_DOMAIN_SETUP(influencerId)}
            className="underline"
          >
            here
          </Link>
        </Alert>
      )}
      {display.domainIsBeingConfigured && (
        <Alert severity="info" className="my-4 bg-[#C2D2EC]">
          We are working hard on getting your domain up and running. Please
          check again later.
        </Alert>
      )}
      {display.domainIsConfigured && domainData && (
        <Alert severity="success" className="my-4">
          Your domain is up and running. You can already start using your
          subdomain&nbsp;
          <a
            href={`https://${domainData.domain}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500"
          >
            {domainData.domain}
          </a>
        </Alert>
      )}
    </div>
  );
};
